import React from 'react';
import useDetectScroll from '@smakss/react-scroll-direction';
import PropTypes from 'prop-types';
import Header from '../../03_organisms/Header';
import OverlayHeader from '../../03_organisms/OverlayHeader';

import styles from './index.module.scss';

const StickyNav = ({
  overlay,
  isStickyButtonMode = false,
  setStickyButtonMode = () => {},
  ...props
}) => {
  const {
    scrollDir,
    scrollPosition: { top },
  } = useDetectScroll();

  return overlay ? (
    <div className={`sticky-nav ${styles['sticky-nav']} ${top <= 55 ? 'top' : ''}`}>
      <OverlayHeader {...props} isTop={top <= 55} />
    </div>
  ) : (
    <>
      <div className={styles['empty-space-behind-nav']} />
      <div
        className={`sticky-nav ${styles['sticky-nav']} ${top <= 65 ? 'top' : ''} ${isStickyButtonMode ? styles[`sticky-button-mode--${scrollDir === 'down' && top > 65 ? 'invisible' : 'visible'}`] : ''}`}
      >
        <Header
          {...props}
          scrollDirection={scrollDir}
          setStickyButtonMode={setStickyButtonMode}
          isStickyButtonMode={isStickyButtonMode}
        />
      </div>
    </>
  );
};

StickyNav.propTypes = {
  overlay: PropTypes.bool,
  isStickyButtonMode: PropTypes.bool,
  setStickyButtonMode: PropTypes.func,
};

export default StickyNav;
